import React from 'react';
import { Link } from 'react-router-dom';

/**
 * PricingCard Component
 * 
 * Individual pricing plan card with glassmorphic design
 */
export const PricingCard = ({ plan }) => {
  return (
    <div
      className="card p-4 md:p-6 lg:p-8 rounded-card glass-bg-card transition-all duration-300 shadow-card relative overflow-hidden group hover:-translate-y-2 hover:shadow-card-hover hover:border-white/20 text-center flex flex-col h-full w-full max-w-[300px] mx-auto"
    >
      {/* Card overlays on hover */}
      <div className="absolute top-0 left-0 w-full h-full bg-card-overlay opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
      <div className="absolute -top-1/2 -left-1/2 w-[200%] h-[200%] bg-card-radial-overlay opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />

      {/* Plan name */}
      <h3 className="text-lg md:text-xl lg:text-card-title mb-2 text-text-primary relative z-10">
        {plan.name}
      </h3>

      {/* Plan price */}
      <div className="plan-price text-3xl md:text-4xl lg:text-plan-price font-semibold text-text-primary my-3 md:my-4 relative z-10">
        {plan.price}
        {plan.period && (
          <span className="text-plan-price-span font-normal text-text-secondary ml-2">
            {plan.period}
          </span>
        )}
      </div>

      {/* Features list */}
      <ul className="plan-features list-none p-0 my-4 md:my-6 lg:my-8 text-left flex-1 mb-4 md:mb-6 relative z-10">
        {plan.features.map((feature, index) => (
          <li
            key={index}
            className="py-3 text-text-secondary text-plan-features relative pl-6 before:content-['✓'] before:absolute before:left-0 before:text-text-primary before:font-semibold"
          >
            {feature}
          </li>
        ))}
      </ul>

      {/* CTA Button */}
      {plan.buttonStyle === 'gray' ? (
        <Link
          to="/register"
          className="btn-gray w-full mt-auto px-4 md:px-5 lg:px-6 py-3 md:py-3 text-nav-btn font-medium rounded-btn-primary min-h-[48px] flex items-center justify-center bg-gray-600/80 text-white border border-gray-500/50 cursor-pointer transition-all duration-300 hover:bg-gray-600 hover:-translate-y-0.5 active:scale-[0.98] relative z-10 no-underline backdrop-blur-md touch-manipulation"
        >
          {plan.buttonText}
        </Link>
      ) : plan.buttonType === 'primary' ? (
        <Link
          to="/register"
          className="btn-primary w-full mt-auto px-4 md:px-5 lg:px-6 py-3 md:py-3 text-nav-btn font-medium rounded-btn-primary min-h-[48px] flex items-center justify-center bg-btn-bg text-btn-text border border-white/20 cursor-pointer transition-all duration-300 shadow-btn-primary hover:shadow-btn-primary-hover hover:-translate-y-0.5 active:scale-[0.98] relative z-10 no-underline backdrop-blur-btn-primary touch-manipulation"
        >
          {plan.buttonText}
        </Link>
      ) : (
        <Link
          to="/register"
          className="btn-outline w-full mt-auto px-4 md:px-5 lg:px-6 py-3 md:py-3 text-nav-btn font-medium rounded-btn-outline min-h-[48px] flex items-center justify-center bg-transparent text-text-primary border border-white/20 cursor-pointer transition-all duration-300 hover:bg-white/10 hover:border-white/30 hover:-translate-y-0.5 hover:shadow-btn-outline-hover active:scale-[0.98] relative z-10 no-underline backdrop-blur-btn-outline touch-manipulation"
        >
          {plan.buttonText}
        </Link>
      )}
    </div>
  );
};

